<template>
  <b-modal
    id="change-email-modal"
    centered
    title="Change Your Email"
    @hide="resetData"
    ref="change_email_modal"
  >
    <b-form @submit="submit" @input="formInput">
      <b-form-group
        :invalid-feedback="formErrors.email"
        :state="fieldState.email"
        label="Email address to change to"
      >
        <b-form-input
          id="email"
          v-model="form.email"
          type="email"
          :state="fieldState.email"
          required
        ></b-form-input>
      </b-form-group>
    </b-form>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="light" @click="cancel()">Cancel</b-button>
      <StatefulButton
        :error="error"
        :loading="submitting"
        loadingText="Saving..."
        text="Save"
        variant="primary"
        @click="submit"
      />
    </template>
  </b-modal>
</template>

<script>
import StatefulButton from "@/components/actions/StatefulButton";

import { UserService } from "@/services";
import { validateRequired, checkFormErrors } from "@/utils/validators";

export default {
  name: "change-email",
  props: ["userObj"],
  data() {
    return {
      form: {
        email: ""
      },
      formErrors: {},
      error: false,
      submitting: false
    };
  },
  components: {
    StatefulButton
  },
  computed: {
    fieldState() {
      return checkFormErrors(this.formErrors);
    }
  },
  methods: {
    async submit(event) {
      event.preventDefault();
      this.submitting = true;
      try {
        this.validateForm();
        const { email, message } = await UserService.changeEmail(
          this.form.email
        );
        this.$store.dispatch("toast", {
          message
        });
        this.$store.dispatch("user/updateProfile", { email });
        this.$refs.change_email_modal.hide();
      } catch (err) {
        this.formErrors = err;
        this.error = true;
        this.submitting = false;
      }
    },
    validateForm() {
      let { errors, valid } = validateRequired(this.form);
      if (!errors.email && this.form.email === this.userObj.email) {
        errors.email = "Put a different email";
        valid = false;
      }
      if (valid === false) throw errors;
    },
    formInput(event) {
      event.preventDefault();
      this.error = false;
      this.formErrors = {};
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.apply(this));
    }
  }
};
</script>

<style lang="scss" scoped></style>
